import * as cx from 'classnames';
import * as React from 'react';
import styles from './AdformInview.mscss';

declare const window: any;

interface OwnProps {
    className?: string;
    placementId: number;
    passback: React.ReactNode;
}

interface State {
    passbacked: boolean;
    expanded: boolean;
}

type Props = OwnProps;

class AdformInview extends React.Component<Props, State> {

    public state: State = {
        passbacked: false,
        expanded: false,
    };

    private adformContainer: HTMLDivElement;
    private dispose: () => void;

    private onInit: any[];
    private onEmpty: any[];

    public constructor(props) {
        super(props);

        const self: AdformInview = this; // tslint:disable-line
        this.onInit = [
            'on.init',
            function(settings) {
                this.on('collapse', onCollapse);
                this.on('expand', onExpand);

                if (self.dispose) {
                    self.dispose();
                }
                self.dispose = () => {
                    this.off('collapse', onCollapse);
                    this.off('expand', onExpand);
                };

                const collapseTimeout = settings.options.hideTime * 1000;

                function onCollapse() {
                    setTimeout(() => {
                        self.setState({ expanded: false });
                    }, collapseTimeout);
                }

                function onExpand() {
                    self.setState({ expanded: true });
                }
            },
        ];

        this.onEmpty = [`${this.props.placementId}.pmp.empty`, () => {
            this.setState({ passbacked: true });
        }];
    }

    public componentDidMount() {
        window._adform = window._adform || [];
        window._adform.push(this.onInit);
        window._adform.push(this.onEmpty);

        const scriptTag = document.createElement('script');
        scriptTag.setAttribute('data-pmp-id', this.props.placementId.toString());
        scriptTag.setAttribute('data-close-oncomplete', 'false');
        scriptTag.setAttribute('data-init-on-inscreen', 'false');
        scriptTag.setAttribute('data-sound-onhover', 'false');
        scriptTag.src = 'https://s1.adform.net/banners/scripts/video/outstream/inview.js';
        this.adformContainer.appendChild(scriptTag);
    }

    public componentWillUnmount() {
        // Clear handlers
        window._adform = window._adform.filter((i) => i !== this.onInit && i !== this.onEmpty);
        if (this.dispose) {
            this.dispose();
        }
    }

    public render() {
        const { className, passback } = this.props;
        const { passbacked, expanded } = this.state;

        return (
            <div className={cx(styles.AdformInview, className)}>
                <div
                    id="adform-outstream"
                    className={cx(styles.AdformInview__adform, expanded && styles['AdformInview__adform--expanded'])}
                    style={{ height: '0', overflow: 'hidden' }}
                    ref={(r) => this.adformContainer = r}
                />
                {passbacked && passback}
            </div>
        );
    }

}

export default AdformInview;
